import mixpanel from 'mixpanel-browser';

import { getOptionalEnv } from './getEnv';

export const initMixpanel = () => {
  const token = getOptionalEnv('VITE_MIXPANEL_TOKEN');
  if (token) {
    mixpanel.init(token, {
      autocapture: true,
      record_sessions_percent: 100,
    });
  }
};

export const isMixpanelEnabled = () => !!getOptionalEnv('VITE_MIXPANEL_TOKEN');

// Typed event tracking
export const trackAccountConnected = (props: {
  accountId: string;
  accountType: string;
  accountSubtype: string;
  bankName: string;
  bankId: string;
  isFirstAccount: boolean;
  isReconnection: boolean;
}) => {
  if (isMixpanelEnabled()) {
    mixpanel.track('Account Connected', props);
  }
};

export const trackPlaidLinkOpened = () => {
  if (isMixpanelEnabled()) {
    mixpanel.track('Plaid Link Opened');
  }
};

export const trackPlaidLinkExited = (props: { hadError: boolean }) => {
  if (isMixpanelEnabled()) {
    mixpanel.track('Plaid Link Exited', props);
  }
};

export const incrementPeopleProperty = (property: string, value: number) => {
  if (isMixpanelEnabled()) {
    mixpanel.people.increment(property, value);
  }
};
